// 国家区号数据
import IndiaImg from '@/features/user-center/images/currency-icon/INR.png';
import type { StaticImageData } from 'next/image';
export interface CountryCode {
  code: string; // 区号
  country: string; // 国家名称
  icon: StaticImageData | string; // 国旗emoji或SVG
  name: string; // 国家英文名
}

export const countryCodes: CountryCode[] = [
  {
    code: '+91',
    country: 'IN',
    icon: IndiaImg,
    name: 'India'
  },
  // {
  //   code: '+1',
  //   country: 'US',
  //   icon: UnitedStatesImg,
  //   name: 'United States'
  // },
];

// 默认选中的国家（中国）
export const defaultPhoneCountry = countryCodes[0];
